export default "__VITE_ASSET__DMuJFCyg__"